import { OPTIMISTIC_TYPE } from '../actionTypes.js';
export default function createOptimistic(endpoint, _ref) {
  let {
    args,
    fetchedAt
  } = _ref;

  var _endpoint$dataExpiryL;

  const expiryLength = (_endpoint$dataExpiryL = endpoint.dataExpiryLength) != null ? _endpoint$dataExpiryL : 60000;
  /* istanbul ignore next */

  if (process.env.NODE_ENV === 'development' && expiryLength < 0) {
    throw new Error('Negative expiry length are not allowed.');
  }

  const now = Date.now();
  const meta = {
    args,
    fetchedAt,
    date: now,
    expiresAt: now + expiryLength,
    // For legacy support; TODO: remove
    schema: endpoint.schema,
    key: endpoint.key(...args)
  }; // For legacy support; TODO: remove

  if (endpoint.update) meta.update = endpoint.update;
  if (endpoint.errorPolicy) meta.errorPolicy = endpoint.errorPolicy;
  const action = {
    type: OPTIMISTIC_TYPE,
    endpoint,
    meta
  };
  return action;
}
/** Future action shape
{
  type: OPTIMISTIC_TYPE,
  endpoint,
  meta: {
    args,
    date,
    expiresAt,
    fetchedAt,
  },
  error?: true,
} */